import { getCached, getFromCache } from "./client";

const API_BASE = process.env.REACT_APP_API_URL;

export async function getHome() {
    return await getCached(`${API_BASE}getHome.php`, { datas: [], album: [] });
}
export function getHomeCache() {
    return getFromCache(`${API_BASE}getHome.php`);
}

export async function getPostural() {
    return await getCached(`${API_BASE}getPostural.php`, { datas: [], album: [] });
}
export function getPosturalCache() {
    return getFromCache(`${API_BASE}getPostural.php`);
}

export async function getTrainer() {
    return await getCached(`${API_BASE}getTrainer.php`, { datas: [], album: [] });
}
export function getTrainerCache() {
    return getFromCache(`${API_BASE}getTrainer.php`);
}

export async function getManagement() {
    return await getCached(`${API_BASE}getManagement.php`, { datas: [], album: [] });
}
export function getManagementCache() {
    return getFromCache(`${API_BASE}getManagement.php`);
}

export async function getCertification() {
    return await getCached(`${API_BASE}getCertification.php`, { datas: [], album: [] });
}
export function getCertificationCache() {
    return getFromCache(`${API_BASE}getCertification.php`);
}

export async function getTeam() {
    return await getCached(`${API_BASE}getTeam.php`, { datas: [], album: [] });
}
export function getTeamCache() {
    return getFromCache(`${API_BASE}getTeam.php`);
}

export async function getContact() {
    return await getCached(`${API_BASE}getContact.php`, []);
}
export function getContactCache() {
    return getFromCache(`${API_BASE}getContact.php`);
}

export async function getFooter() {
    return await getCached(`${API_BASE}getFooter.php`, []);
}
export function getFooterCache() {
    return getFromCache(`${API_BASE}getFooter.php`);
}

export async function getGallery() {
    return await getCached(`${API_BASE}getGallery.php`, { studio: [], gymManagement: [], certification: [] });
}
export function getGalleryCache() {
    return getFromCache(`${API_BASE}getGallery.php`);
}

export async function getNavigation() {
    return await getCached(`${API_BASE}getNavigation.php`, []);
}
export function getNavigationCache() {
    return getFromCache(`${API_BASE}getNavigation.php`);
}
